import {
  clearAccessContext,
  getAccessContext
} from '../services/accessContext'
import {
  clearRouteReferenceCache,
  setRouteReferenceAccount
} from '../common/routeRecordId'
import { publicRouteReferencePolicy } from './publicRouteReferencePolicy'
import { accessDeniedReason, canAccessPath } from '../utils/accessPolicy'

const PUBLIC_ROUTE_NAMES = new Set([
  'Login',
  'SendEmail',
  'ConfirmEmail',
  'ResetPassword',
  'ResetComplete',
  'UserError',
  'AccessDenied',
  '契約企業管理者招待'
])

let installed = false

function clearSessionCaches () {
  clearAccessContext()
  clearRouteReferenceCache()
  setRouteReferenceAccount(null)
}

function accessDeniedTarget (to, reason = '') {
  const query = {}
  // レコードURLは数値主キーやUUIDをAccessDeniedのqueryへ複製しない。
  if (!publicRouteReferencePolicy(to)) {
    query.from = to.fullPath
  }
  if (reason) query.reason = reason
  return {
    name: 'AccessDenied',
    query,
    replace: true
  }
}

export default function installAccessContextGuard (router) {
  if (installed) return
  installed = true

  router.beforeEach((to, from, next) => {
    if (PUBLIC_ROUTE_NAMES.has(to.name)) {
      if (to.name === 'Login') clearSessionCaches()
      next()
      return
    }

    getAccessContext()
      .then(context => {
        setRouteReferenceAccount(context.accountId)
        if (canAccessPath(context, to.path)) {
          next()
          return
        }
        next(accessDeniedTarget(to, accessDeniedReason(context, to.path)))
      })
      .catch(error => {
        const status = error && error.response ? Number(error.response.status) : 0
        if (status === 401) {
          clearSessionCaches()
          next({ name: 'Login' })
          return
        }
        next(accessDeniedTarget(
          to,
          error && error.code ? error.code : 'ACCESS_CONTEXT_ERROR'
        ))
      })
  })
}
